module.exports = __webpack_public_path__ + "static/media/key-message-benefits-288w.0a93d231.png";